import { ChangeEvent, FC, useState } from 'react';
import { Input } from 'components/fields/Input/Input';
import { Button } from 'components/Button/Button';
import { EMAIL_PATTERN } from 'constants/index';
import { useFetch } from './hooks/useFetch';
import { Scrollbar } from 'components/Scrollbar/Scrollbar';
import image from './img/FinalScreen.webp';
import * as S from './SendFeedback.styled';
import { TriangleIcon } from 'assets/svg';

const EMAIL_ERROR_MESSAGE = 'Invalid email';

interface ISendFeedbackProps {
  sentToEmailCallback: () => void;
  summary: string;
  sessionKey: string;
}

export const SendFeedback: FC<ISendFeedbackProps> = ({
  summary,
  sentToEmailCallback,
  sessionKey
}) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [thankScreen, setThankScreen] = useState(false);

  const { sendToEmailMutation } = useFetch();

  const emailValidator = (value: string) => {
    if (!EMAIL_PATTERN.test(value)) {
      setError(EMAIL_ERROR_MESSAGE);
      return true;
    }

    setError('');
  };

  const onChangeEmail = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    setEmail(value);
    emailValidator(value);
  };

  const sendToEmailHandler = () => {
    sendToEmailMutation({email, sessionKey});
    setThankScreen(true);
  };

  const renderEmailWrapperContent = () => {
    if (thankScreen === false) {
      return (
        <S.EmailWrapper>
          <S.EmailDescription>
            <S.EmailHeader>🎁 Your reward is ready!</S.EmailHeader>
            <S.EmailText>You're almost there! One small step left — enter your email, and we will send your well-earned reward straight to your inbox!</S.EmailText>
          </S.EmailDescription>
          <S.EmailInputWrapper>
            <S.EmailInput
              error={error}
              value={email}
              onChange={onChangeEmail}
              placeholder="Email*"
            />
            <S.BottomButton onClick={sendToEmailHandler} disabled={Boolean(error)}>
              <S.ButtonText>SEND</S.ButtonText>
              <S.ButtonContent>
                <TriangleIcon />
                <TriangleIcon />
                <TriangleIcon />
              </S.ButtonContent>
            </S.BottomButton>
          </S.EmailInputWrapper>
        </S.EmailWrapper>
      )
    } else {
      return(
        <S.ThankWrapper>
          <S.ThankTitle>🎉 Thanks for participating!</S.ThankTitle>
          <S.ThankText>Check your email</S.ThankText>
        </S.ThankWrapper>
      )
    }
  }

  const generateSummaryItems = () => {
    const summaryItems = JSON.parse(summary).services;
    if (summaryItems?.length) {
      return (
        <S.ResultsList>
          {summaryItems.map((summaryItem: string, index: number) => {
            return (
              <S.ResultItem key={index}>{summaryItem}</S.ResultItem>
            )
          })}
        </S.ResultsList>
      )
    }
    return null;
  }

  return (
    <S.Wrapper>
      <S.ResultWrapper>
        <S.ResultPageImage src={image} alt="question image" />
        <S.ResultDescription>
          <S.ResultTitle>Thanks for your answers!</S.ResultTitle>
          <S.ResultHelp>Here's how we can help:</S.ResultHelp>
          <S.ResultsList>
            {generateSummaryItems()}
          </S.ResultsList>
        </S.ResultDescription>
      </S.ResultWrapper>

      {renderEmailWrapperContent()}
    </S.Wrapper>
  );
};
